import config from 'config';

const baseUrl = config.api[window.location.hostname].baseUrl;

const track = payload => {
  try {
    const token = window.user && window.user.token;

    if (!token) {
      return Promise.resolve();
    }

    return fetch(`${baseUrl}/mod/moderation/telemetry`, {
      method: 'POST',
      keepalive: true,
      headers: {
        Authorization: token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    }).catch(() => undefined);
  } catch (error) {
    return Promise.resolve();
  }
};

const moderationTelemetry = {
  track,
};

export default moderationTelemetry;
